import { useState, useContext, useEffect } from 'react';
import { GlobalContext } from 'GlobalContext';
import { message, Spin, Tooltip, Upload, Popconfirm, InputNumber } from 'antd';
import api from 'api';
import { get } from 'utils/fetch';
import { isPhoneSize } from 'utils/util';
import {
    FileOutlined,
    CloseCircleFilled,
    PlusOutlined,
} from '@ant-design/icons';
export function OtherInfo() {
    const { manageAssetId, setManageAssetId, accessToken, refreshSession } =
        useContext(GlobalContext);
    const [messageApi, contextHolder] = message.useMessage();
    const [propertyOtherInfo, setPropertyOtherInfo] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [loading, setLoading] = useState(true);

    // fields
    const [sb9AffidavitSignatory, setSb9AffidavitSignatory] = useState(null);
    const [notes, setNotes] = useState(null);

    const entryStyle = {
        margin: '20px',
        fontSize: '20px',
    };

    const inputStyle = {
        border: '0',
        outline: 'none',
        borderBottom: '1px solid black',
        fontSize: '20px',
        background: 'transparent',
    };

    const displayErrorMessage = (message) => {
        messageApi.open({
            type: 'error',
            content: message,
        });
    };

    async function fetchPropertyOtherInfo(manageAssetId) {
        await get(
            api.asset.propertyOtherInfo(manageAssetId),
            setPropertyOtherInfo,
            (errors) =>
                errors.forEach((err) => {
                    displayErrorMessage(err.message);
                }),
            accessToken
        );
        refreshSession();
        setLoading(false);
    }

    useEffect(() => {
        if (propertyOtherInfo) {
            restore(propertyOtherInfo);
        }
    }, [propertyOtherInfo]);

    useEffect(() => {
        if (manageAssetId < 0) {
            return;
        }
        fetchPropertyOtherInfo(manageAssetId);
    }, []);

    function restore(propertyOtherInfo) {
        setSb9AffidavitSignatory(propertyOtherInfo?.sb9_affidavit_signatory);
        setNotes(propertyOtherInfo?.notes);
    }

    function unchanged() {
        if (!propertyOtherInfo) return false;
        return (
            sb9AffidavitSignatory ===
                propertyOtherInfo.sb9_affidavit_signatory &&
            notes === propertyOtherInfo.notes
        );
    }

    async function upsert() {
        if (unchanged()) return;
        setLoading(true);
        const body = JSON.stringify({
            sb9AffidavitSignatory,
            notes,
        });

        const options = {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body,
        };
        const response = await fetch(
            api.asset.upsertOther(manageAssetId),
            options
        );
        const data = await response.json();
        const idRes = data.data;
        refreshSession();
        if (idRes === 0) {
            messageApi.error({
                type: 'error', // or 'error', 'info', 'warning', 'loading'
                content: propertyOtherInfo?.id
                    ? 'Other insertion failed'
                    : 'Other update failed',
                duration: 3, // seconds (optional)
            });
        } else {
            messageApi.open({
                type: 'success', // or 'error', 'info', 'warning', 'loading'
                content: propertyOtherInfo?.id
                    ? 'Other insertion success'
                    : 'Other update success',
                duration: 3, // seconds (optional)
            });
            fetchPropertyOtherInfo(manageAssetId);
        }
        setEditMode(false);
    }

    async function deleteOther() {
        setLoading(true);

        const options = {
            method: 'DELETE',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const response = await fetch(
            api.asset.deleteOther(manageAssetId),
            options
        );
        const data = await response.json();
        const idRes = data.data;
        refreshSession();

        if (idRes === 0 || !idRes) {
            messageApi.error({
                type: 'error',
                content: 'Loan deletion failed',
                duration: 3,
            });
        } else {
            messageApi.open({
                type: 'success',
                content: 'Loan deletion success',
                duration: 3,
            });
        }
        setPropertyOtherInfo(null);
        restore(null);
        setLoading(false);
    }

    return (
        <>
            {contextHolder}
            {loading && (
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                    <Spin />
                </div>
            )}
            {!loading && (
                <div>
                    <div
                        style={{
                            width: 'fit-content',
                            marginLeft: '20px',
                            height: '38px',
                            position: 'fixed',
                            background: 'white',
                            width: '100%',
                            alignContent: 'end',
                            top: 40,
                        }}
                    >
                        <div
                            style={{
                                color: 'blue',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                width: 'fit-content',
                            }}
                            onClick={(e) => {
                                if (editMode) {
                                    restore(propertyOtherInfo);
                                }
                                setEditMode(!editMode);
                            }}
                        >
                            {editMode ? 'Restore' : 'Edit'}
                        </div>
                    </div>

                    <div
                        style={
                            isPhoneSize()
                                ? entryStyle
                                : {
                                      ...entryStyle,
                                      display: 'flex',
                                      marginTop: '50px',
                                  }
                        }
                    >
                        {editMode && (
                            <>
                                <div>SB9 Affidavit Signatory: </div>
                                <input
                                    style={inputStyle}
                                    value={sb9AffidavitSignatory || ''}
                                    onInput={(e) => {
                                        setSb9AffidavitSignatory(
                                            e.target.value
                                        );
                                    }}
                                ></input>
                            </>
                        )}

                        {!editMode &&
                            `SB9 Affidavit Signatory: ${
                                sb9AffidavitSignatory || ''
                            }`}
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '400px',
                            marginBottom: '4px',
                        }}
                    >
                        <div style={{ fontSize: '20px', marginLeft: '20px' }}>
                            Notes:
                        </div>
                        {editMode ? (
                            <textarea
                                style={{
                                    outline: 'none',
                                    border: '1px solid black',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    resize: 'vertical', // allows user to resize vertically
                                    minHeight: '100px',
                                    fontFamily: 'inherit',
                                    fontSize: '14px',
                                    marginLeft: '20px',
                                }}
                                value={notes || ''}
                                onInput={(e) => {
                                    const value = e.target.value;
                                    setNotes(value);
                                }}
                            ></textarea>
                        ) : (
                            <div
                                style={{
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    backgroundColor: '#f9f9f9',
                                    whiteSpace: 'pre-wrap',
                                    minHeight: '34px',
                                    marginLeft: '20px',
                                }}
                            >
                                {notes}
                            </div>
                        )}
                    </div>

                    <div style={{ display: 'flex', marginLeft: '20px' }}>
                        <button
                            style={{
                                height: '30px',
                                width: '60px',
                                borderRadius: '30px',
                                background: 'rgb(17 32 86)',
                                color: 'white',
                                cursor: 'pointer',
                            }}
                            onClick={upsert}
                        >
                            Save
                        </button>
                        <button
                            style={{
                                height: '30px',
                                width: '60px',
                                borderRadius: '30px',
                                background: 'rgb(86 17 17)',
                                color: 'white',
                                cursor: 'pointer',
                            }}
                            onClick={() => {
                                if (
                                    window.confirm(
                                        'Are you sure you want to delete this loan?'
                                    )
                                ) {
                                    deleteOther();
                                }
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            )}
        </>
    );
}
